import {Button, Card} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {
  APP_UPDATE_SIMULATION_EVENT,
  browserStorageKey,
  RELEASE_BRANCH_PATTERN,
  RELEASE_TAG_PATTERN,
} from '@dms/config';

const DUMMY_RELEASE_REF = 'OMNETIC-release-1.0.0';
const DEFAULT_PATCH = '0';
const VERSION_INCREMENT = 1;
const FIRST_PATCH = 1;
const LOCAL_BUILD_LABEL = 'dummy (local build)';

interface AppUpdateSimulationProps {
  onSimulatePatch: () => void;
}

export function AppUpdateSimulation(props: AppUpdateSimulationProps) {
  const releaseMatch =
    process.env.RELEASE_REF?.match(RELEASE_TAG_PATTERN) ??
    process.env.RELEASE_REF?.match(RELEASE_BRANCH_PATTERN);
  const base = releaseMatch?.[0] ?? DUMMY_RELEASE_REF;
  const [, major, minor, patch = DEFAULT_PATCH] =
    releaseMatch ?? DUMMY_RELEASE_REF.match(RELEASE_TAG_PATTERN) ?? [];

  const simulateUpdate = (kind: 'release' | 'patch') => {
    const nextMinor = Number(minor) + (kind === 'release' ? VERSION_INCREMENT : 0);
    const nextPatch = kind === 'release' ? FIRST_PATCH : Number(patch) + VERSION_INCREMENT;
    const deployedRef = `OMNETIC-release-${major}.${nextMinor}.${nextPatch}`;
    sessionStorage.setItem(
      browserStorageKey.APP_UPDATE_SIMULATION,
      JSON.stringify({runningRef: base, deployedRef})
    );
    window.dispatchEvent(new Event(APP_UPDATE_SIMULATION_EVENT));
  };

  return (
    <Card title="App update simulation" variant="inlineGrey">
      <VStack spacing={2}>
        <Text size="xSmall" color="tertiary">
          {`Running ref: ${isNil(releaseMatch) ? LOCAL_BUILD_LABEL : base}`}
        </Text>
        <Button
          title="Simulate minor release"
          variant="secondary"
          onClick={() => simulateUpdate('release')}
          data-testid="devSettings-appUpdateSimulation-minorReleaseButton"
        />
        <Button
          title="Simulate patch"
          variant="secondary"
          onClick={() => {
            simulateUpdate('patch');
            props.onSimulatePatch();
          }}
          data-testid="devSettings-appUpdateSimulation-patchButton"
        />
      </VStack>
    </Card>
  );
}
